import React from "react";
import styled from "styled-components";
import categories from "../data/categories";
import cities from "../data/cities";
import { useLang } from "../i18n/LanguageContext";

export default function FilterBar({ filters, setFilters }) {
  const { t, lang } = useLang();
  const set = (key, value) => setFilters((f) => ({ ...f, [key]: value }));

  return (
    <Wrap id="explore">
      <Bar>
        <Pills>
          <Pill $active={filters.category === "all"} onClick={() => set("category", "all")}>
            {t("filter.all")}
          </Pill>
          {categories.map((c) => (
            <Pill key={c.id} $active={filters.category === c.id} onClick={() => set("category", c.id)}>
              {c[lang]}
            </Pill>
          ))}
        </Pills>
        <Selects>
          <select value={filters.city} onChange={(e) => set("city", e.target.value)}>
            <option value="all">{t("filter.cityAll")}</option>
            {cities.map((c) => (
              <option key={c} value={c}>{c}</option>
            ))}
          </select>
          <select value={filters.type} onChange={(e) => set("type", e.target.value)}>
            <option value="all">{t("filter.typeAll")}</option>
            <option value="company">{t("filter.typeCompany")}</option>
            <option value="individual">{t("filter.typeIndividual")}</option>
          </select>
        </Selects>
      </Bar>
    </Wrap>
  );
}

const Wrap = styled.div`
  position: sticky;
  top: 57px;
  z-index: 40;
  background: ${({ theme }) => theme.colors.cream};
  border-top: 1px solid ${({ theme }) => theme.colors.hair};
  border-bottom: 1px solid ${({ theme }) => theme.colors.hair};
`;

const Bar = styled.div`
  max-width: ${({ theme }) => theme.maxWidth};
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px clamp(16px, 5vw, 40px);
  overflow-x: auto;
  scrollbar-width: none;
  &::-webkit-scrollbar { display: none; }
`;

const Pills = styled.div`
  display: flex;
  gap: 8px;
  flex: 1 1 auto;
`;

const Pill = styled.button`
  white-space: nowrap;
  font-size: 13.5px;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 100px;
  transition: 0.18s;
  border: 1px solid ${({ $active, theme }) => ($active ? theme.colors.green : theme.colors.hair)};
  background: ${({ $active, theme }) => ($active ? theme.colors.green : "transparent")};
  color: ${({ $active, theme }) => ($active ? theme.colors.cream : theme.colors.inkSoft)};
  &:hover { border-color: ${({ theme }) => theme.colors.green}; }
`;

const Selects = styled.div`
  display: flex;
  gap: 10px;
  flex: 0 0 auto;
  select {
    font-family: inherit;
    font-size: 13.5px;
    color: ${({ theme }) => theme.colors.ink};
    background: ${({ theme }) => theme.colors.surface};
    border: 1px solid ${({ theme }) => theme.colors.hair};
    padding: 9px 14px;
    border-radius: 100px;
    cursor: pointer;
    outline: none;
  }
  @media (max-width: 760px) { display: none; }
`;
